import { render, staticRenderFns } from "./alumniReportTable.vue?vue&type=template&id=317429df&scoped=true"
import script from "./alumniReportTable.vue?vue&type=script&lang=js"
export * from "./alumniReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317429df",
  null
  
)

export default component.exports